import React from 'react';
import { useUI } from '../../contexts/UIContext';
import './FitnessBadge.css';

export const getFitnessTier = (fitness: number): { label: string, className: string, description: string, color: string } => {
    if (fitness > 90) return { label: 'Peak', className: 'fitness-peak', description: 'Peak Condition (91-100%)', color: '#00ff9b' };
    if (fitness > 80) return { label: 'Fresh', className: 'fitness-fresh', description: 'Fresh & Ready (81-90%)', color: '#76ff03' };
    if (fitness > 60) return { label: 'Fit', className: 'fitness-fit', description: 'Match Fit (61-80%)', color: '#c6ff00' };
    if (fitness > 40) return { label: 'Tiring', className: 'fitness-tiring', description: 'Tiring (41-60%)', color: '#ffeb3b' };
    if (fitness > 20) return { label: 'Jaded', className: 'fitness-jaded', description: 'Jaded (21-40%)', color: '#ff9800' };
    if (fitness > 10) return { label: 'Exhausted', className: 'fitness-exhausted', description: 'Exhausted (11-20%)', color: '#ff5722' };
    return { label: 'Risk', className: 'fitness-risk', description: 'High Injury Risk (0-10%)', color: '#f44336' };
};

interface FitnessBadgeProps {
    fitness: number;
}

export const FitnessBadge: React.FC<FitnessBadgeProps> = ({ fitness }) => {
    const { openFitnessInfoModal } = useUI();
    const tier = getFitnessTier(fitness);
    const title = `Fitness: ${fitness}% (${tier.description}). Click for more info.`;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        openFitnessInfoModal(fitness);
    };

    return (
        <button className="fitness-badge-button" onClick={handleClick} title={title}>
            <span className={`fitness-badge ${tier.className}`}>
                {tier.label}
            </span>
        </button>
    );
};
